// extracted by mini-css-extract-plugin
export default {"wrap":"SampleMenuComponent_wrap__6VKd-","blockInfo":"SampleMenuComponent_blockInfo__zRS7y"};